import { ClassProps } from "@/lib/types/class-props";
import { cx } from "@/lib/utils/className.utils";
import { Transition, Menu } from "@headlessui/react";
import { Fragment } from "react";

export type ModalProps = {
  title?: string;
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  containerClassName?: string;
} & ClassProps;

const FullScreenModalAlt = ({
  open,
  children,
  className,
  containerClassName,
}: ModalProps) => {
  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Menu as="div" className={cx("relative z-[2000]", className)}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-background" />
          </Transition.Child>

          <div className="fixed inset-0">
            <div className="flex h-full items-center justify-center text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-100"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-100"
              >
                <div
                  className={cx(
                    "w-full h-full transform overflow-scroll text-left transition-all flex flex-col justify-between",
                    containerClassName
                  )}
                >
                  <div className="h-full flex flex-col">{children}</div>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Menu>
      </Transition>
    </>
  );
};

export default FullScreenModalAlt;
